<template>
  <div v-if="flag">
    <slot :model="model"></slot>
  </div>
</template>
<script>
  import userService from '@/services/bylBaseCenter/user/userinfo'
  import transform from 'lodash.transform'
  export default {
    data() {
      return {
        flag: false,
        model: false
      }
    },
    created () {
      userService.getRoles().then((r) => {
        let a = transform(r.data, function(result, n) {
          return result.push(n.role);
        }, []);
        if (r.data) {
          this.model = !this.isGuest(a)
        } else {
          this.model = false
        }
        this.flag = true
      })
    },
    methods: {
      isGuest (roles) {
        /*
            <option value="4">教师</option>
            <option value="3">游客</option>
            <option value="2">机构管理员</option>
            <option value="1">超级管理员</option> */
        if (roles) {
          return roles.length == 1 && this.$utils.findElem(roles, 'type', '3') > -1
        }
      },
      isPlatAdmin (roles) {
        if (roles) {
          return this.$utils.findElem(roles, 'type', '1') > -1
        }
        return false
      },
      isOrgAdmin (roles) {
        if (roles) {
          return this.$utils.findElem(roles, 'type', '2') > -1
        }
        return false
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/containers/auth/containerGetRoles.vue